import { render, staticRenderFns } from "./ProductsPriceEdit.vue?vue&type=template&id=68fdeb12"
import script from "./ProductsPriceEdit.vue?vue&type=script&lang=js"
export * from "./ProductsPriceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports